/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface CopyUiModuleBody
 */
export interface CopyUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof CopyUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyUiModuleBody
     */
    moduleType: CopyUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof CopyUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof CopyUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof CopyUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof CopyUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {string}
     * @memberof CopyUiModuleBody
     */
    translationKey: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CopyUiModuleBodyModuleTypeEnum {
    COPY = 'COPY'
}



